import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: '100vw',
        maxWidth: '100vw',
        minHeight: 'calc(100vh - 64px - 88px - 85px)',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        bgcolor: '#f5f7fb',
        overflow: 'hidden',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)'
      }}
    >
      {/* 상단 컬러 밴드 */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: { xs: 220, md: 260 },
          bgcolor: '#0e679d'
        }}
      />

      {/* 메인 카드 영역 (내용은 그대로 유지) */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 1,
          py: { xs: 6, md: 8 }
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 960,
            bgcolor: 'white',
            borderRadius: 3,
            boxShadow: '0 14px 50px rgba(0,0,0,0.08)',
            p: { xs: 4, md: 6 },
            textAlign: 'center'
          }}
        >
          {/* 서브 타이틀 */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: '#0e679d',
              fontSize: { xs: '1.2rem', md: '2rem' },
              mb: 2
            }}
          >
            KOREA MEDIS AI 질의응답 시스템
          </Typography>

          {/* 메인 타이틀 */}
          <Typography
            variant="h1"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 800,
              fontSize: { xs: '2rem', sm: '2.4rem', md: '3.2rem' },
              color: '#0b2140',
              mt: 6,
              mb: 6,
              letterSpacing: '-0.02em',
              lineHeight: 1.15
            }}
          >
            데이터로<br />
            새로운 경험을 만듭니다.
          </Typography>

          {/* CTA 버튼 */}
          <Button
            variant="contained"
            size="large"
            startIcon={<AutoAwesomeIcon sx={{ fontSize: { xs: '1.5rem', md: '2rem' } }} />}
            onClick={() => navigate('/user-chat')}
            sx={{
              py: { xs: 2, md: 2.5 },
              px: { xs: 4, md: 7 },
              fontSize: { xs: '1.05rem', md: '1.3rem' },
              fontWeight: 700,
              borderRadius: '999px',
              backgroundColor: '#0e679d',
              boxShadow: '0 10px 30px rgba(14,103,157,0.28)',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#0c5989',
                boxShadow: '0 12px 36px rgba(14,103,157,0.32)'
              }
            }}
          >
            AI 질의응답 시작
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default HomePage;
